import { render, staticRenderFns } from "./RolesController.vue?vue&type=template&id=fb1a686c&"
import script from "./RolesController.vue?vue&type=script&lang=js&"
export * from "./RolesController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports